import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { PortalFaqItem } from "@colab/shared";

// GET /api/portal/faq?limit=N — active FAQ items, sorted by category +
// position. The dashboard passes limit=5; the dedicated FAQ surface in
// sub-bucket 8 omits the limit.
export function usePortalFaq(limit?: number) {
  return useQuery<PortalFaqItem[], ApiClientError>({
    queryKey: queryKeys.portal.faq(limit),
    queryFn: () =>
      apiFetch<PortalFaqItem[]>(
        typeof limit === "number" ? `/portal/faq?limit=${limit}` : "/portal/faq",
      ),
  });
}
